export { type RichTextBlockProps, default as RichTextBlock } from './RichTextBlock';
